import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import withHydrationOnDemand from 'react-hydration-on-demand';
import SiteFooter from './SiteFooter';
const SiteFooterOnDemand = withHydrationOnDemand({
    on: [
        'visible'
    ]
})(SiteFooter);
export default withFeatureBranch({
    mobile_perf: SiteFooterOnDemand
})(SiteFooter);
